var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1764,
    height: 967,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 1329,
    width: 1764,
    height: 967
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-284 -1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.5 1582.49C287.5 1570.35 297.347 1560.5 309.494 1560.5L2023.51 1560.5C2035.65 1560.5 2045.5 1570.35 2045.5 1582.49L2045.5 2267.51C2045.5 2279.65 2035.65 2289.5 2023.51 2289.5L309.494 2289.5C297.347 2289.5 287.5 2279.65 287.5 2267.51Z",
    stroke: "#BFBFBF",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 453 1464)"
  }, "He ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.656,
    y: 0
  }, "works"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 592.969,
    y: 0
  }, "as a        "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -84.8682,
    y: 242
  }, "lawyer"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 210.757,
    y: 242
  }, ": 17.5%")), /*#__PURE__*/React.createElement("path", {
    d: "M368.132 1711.72 516.132 1711.72 664.132 1711.72 664.132 1715.72 516.132 1715.72 368.132 1715.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 368.132 1825)"
  }, "farmer", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 295.625,
    y: 0
  }, ": 9.3%")), /*#__PURE__*/React.createElement("path", {
    d: "M368.132 1830.72 516.132 1830.72 664.132 1830.72 664.132 1834.72 516.132 1834.72 368.132 1834.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 368.132 1944)"
  }, "teacher", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 344.896,
    y: 0
  }, ": 9.1%")), /*#__PURE__*/React.createElement("path", {
    d: "M368.132 1949.72 540.632 1949.72 713.132 1949.72 713.132 1953.72 540.632 1953.72 368.132 1953.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 368.132 2063)"
  }, "journalist", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 492.708,
    y: 0
  }, ": 7.9%")), /*#__PURE__*/React.createElement("path", {
    d: "M368.132 2068.72 532.465 2068.72 696.799 2068.72 861.132 2068.72 861.132 2072.72 696.799 2072.72 532.465 2072.72 368.132 2072.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 368.132 2183)"
  }, "businessman", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 541.979,
    y: 0
  }, ": 5.4% ")), /*#__PURE__*/React.createElement("path", {
    d: "M368.132 2188.72 548.799 2188.72 729.465 2188.72 910.132 2188.72 910.132 2192.72 729.465 2192.72 548.799 2192.72 368.132 2192.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393 1464 1778.29 1464",
    stroke: "#000000",
    strokeWidth: 10.3125,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1270.61 1706)"
  }, "coach", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 2.7%")), /*#__PURE__*/React.createElement("path", {
    d: "M1270.61 1711.72 1393.61 1711.72 1516.61 1711.72 1516.61 1715.72 1393.61 1715.72 1270.61 1715.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1270.61 1825)"
  }, "manager", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 344.896,
    y: 0
  }, ": 2.5%")), /*#__PURE__*/React.createElement("path", {
    d: "M1270.61 1830.72 1443.11 1830.72 1615.61 1830.72 1615.61 1834.72 1443.11 1834.72 1270.61 1834.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1270.61 1944)"
  }, "doctor", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 295.625,
    y: 0
  }, ": 1.7%")), /*#__PURE__*/React.createElement("path", {
    d: "M1270.61 1949.72 1418.61 1949.72 1566.61 1949.72 1566.61 1953.72 1418.61 1953.72 1270.61 1953.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1270.61 2063)"
  }, "salesman", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 394.167,
    y: 0
  }, ": 1.7%")), /*#__PURE__*/React.createElement("path", {
    d: "M1270.61 2068.72 1401.94 2068.72 1533.27 2068.72 1664.61 2068.72 1664.61 2072.72 1533.27 2072.72 1401.94 2072.72 1270.61 2072.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1270.61 2183)"
  }, "carpenter", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 443.437,
    y: 0
  }, ": 1.6% ")), /*#__PURE__*/React.createElement("path", {
    d: "M1270.61 2188.72 1418.27 2188.72 1565.94 2188.72 1713.61 2188.72 1713.61 2192.72 1565.94 2192.72 1418.27 2192.72 1270.61 2192.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1811.53 1464)"
  }, "."))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.08759b3b97af3fe3f33c41b450fdbe5f.svg";
export { ForwardRef as ReactComponent };